<template>
  <div class="my-filter-container-desktop afl">
    <!-- uzi ekran: naslov koji otvara/zatvara filter -->
    <div class="btn-expanded" @click="clickShow">
      <div class="filter-text text-uppercase text-muted">
        Filteri
      </div>

      <ClientOnly>
        <div class="filter-img-awesome text-right">
          <i id="down-awesome" class="esei icon-chevron-down d-block text-muted"></i>
          <i id="up-awesome" class="esei icon-chevron-up d-none text-muted"></i>
        </div>
      </ClientOnly>
    </div>

    <div id="nav-container" class="drop-container p-2">
      <div class="afl-head">
        <span class="afl-title">Filteri</span>
        <button v-if="chips.length" type="button" class="afl-clear" @click="clearAll">Očisti sve</button>
      </div>

      <!-- izabrano: svaki čip se ukloni jednim klikom -->
      <div v-if="chips.length" class="afl-chips">
        <button v-for="chip in chips"
                :key="chip.key"
                type="button"
                class="afl-chip"
                :title="`Ukloni: ${chip.label}`"
                @click="chip.remove()">
          {{ chip.label }}
          <i class="esei icon-close" aria-hidden="true"></i>
        </button>
      </div>

      <!-- kategorije; potkategorije se otvaraju odmah ispod izabrane kategorije -->
      <section class="afl-sec">
        <h5 class="afl-sec-title">Kategorije</h5>

        <div class="afl-search">
          <i class="esei icon-magnifying-glass-solid" aria-hidden="true"></i>
          <input v-model="categoryQuery"
                 type="search"
                 class="afl-input"
                 placeholder="Pronađi kategoriju…"
                 aria-label="Pronađi kategoriju"
                 autocomplete="off" />
        </div>

        <ul class="afl-list">
          <li>
            <button type="button"
                    class="afl-item"
                    :class="{ on: selectAll($route.fullPath) }"
                    @click="allCategories">
              <span>Sve kategorije</span>
            </button>
          </li>

          <li v-for="category in visibleCategories" :key="category.id">
            <button type="button"
                    class="afl-item"
                    :class="{ on: selectBG(selectedCategory, category) }"
                    @click="selectCategory(category)">
              <span>{{ category.name }}</span>
            </button>
          </li>

          <li v-if="!visibleCategories.length" class="afl-empty">{{ categoryQuery ? `Nema kategorije za „${categoryQuery}“.` : 'Nema kategorija.' }}</li>
        </ul>
      </section>

      <section class="afl-sec">
        <h5 class="afl-sec-title">Potkategorije</h5>

        <p v-if="!selectedCategory" class="afl-hint">Prvo izaberite kategoriju.</p>

        <ul v-else class="afl-list">
          <li v-for="subcategory in selectedCategory.subcategories" :key="subcategory.id">
            <button type="button"
                    class="afl-item"
                    :class="{ on: selectBG(selectedSubcategory, subcategory) }"
                    @click="selectSubcategory(subcategory)">
              <span>{{ subcategory?.name }}</span>
            </button>
          </li>
        </ul>
      </section>

      <section class="afl-sec">
        <h5 class="afl-sec-title">Kupujem / prodajem</h5>

        <div class="afl-seg" role="group" aria-label="Kupujem ili prodajem">
          <button v-for="option in optionType"
                  :key="option.text"
                  type="button"
                  class="afl-seg-btn"
                  :class="{ on: currentType === option.value }"
                  @click="setType(option.value)">
            {{ option.text }}
          </button>
        </div>
      </section>

      <section class="afl-sec">
        <h5 class="afl-sec-title">Način plaćanja</h5>

        <div class="afl-seg" role="group" aria-label="Način plaćanja">
          <button v-for="option in optionBuying"
                  :key="option.text"
                  type="button"
                  class="afl-seg-btn"
                  :class="{ on: currentCurrency === option.value }"
                  @click="setCurrency(option.value)">
            {{ option.text }}
          </button>
        </div>
      </section>

      <!-- mesta (samo stari raspored) -->
      <section v-if="routeMode === 'old'" class="afl-sec">
        <h5 class="afl-sec-title">Mesto</h5>

        <div class="afl-search">
          <i class="esei icon-magnifying-glass-solid" aria-hidden="true"></i>
          <input v-model="placeName"
                 type="search"
                 class="afl-input"
                 placeholder="Pretraži mesta"
                 aria-label="Pretraži mesta"
                 autocomplete="off"
                 @input="findPlaceByName" />
        </div>

        <ul ref="infiniteListRef" class="afl-list afl-places infinite-list">
          <li v-for="place in placesList" :key="place.id">
            <button type="button"
                    class="afl-item"
                    :class="{ on: selectBG(selectedPlace, place) }"
                    @click="selectPlace(place)">
              <span>{{ place.name }}</span>
            </button>
          </li>
        </ul>
      </section>
    </div>
  </div>
</template>

<script setup>
import { normalizeText } from '~/composables/useListFilter'
import { useCustomerDistrictStore } from '~/stores/customer/district'
import FilterDataByRoute from '~/components/cmsCustomer/advertisement/utils/FilterDataByRoute'

const useDistrictStore = useCustomerDistrictStore()
const route = useRoute()
const router = useRouter()
const { $srbTolat } = useNuxtApp()

const props = defineProps({
  places: {
    type: Array,
    default: () => []
  },
  categories: {
    type: Array,
    default: () => []
  },
  routeMode: {
    type: String,
    default: 'old' // old | new
  }
})

const {
  getFixed,
  getBuying,
  getType,
  getPage,
  getArrayOfParams,
  arrToStringWithJoin
} = FilterDataByRoute()

const infiniteListRef = ref(null)

const optionType = ref([
  { text: 'sve', value: null },
  { text: 'kupujem', value: 'kupujem' },
  { text: 'prodajem', value: 'prodajem' }
])

const optionBuying = ref([
  { text: 'sve', value: null },
  { text: 'cena', value: 'cena' },
  { text: 'dogovor', value: 'dogovor' }
])

const getTypeAdsValue = () => {
  if (props.routeMode === 'new') {
    return route.query.type_ads ?? null
  }

  return getBuying()
}

const getTypeCurrencyValue = () => {
  if (props.routeMode === 'new') {
    return route.query.type_currency ?? null
  }

  return getType()
}

const filterData = ref({
  category_id: 0,
  subcategory_id: 0,
  fixed: getFixed(),
  type_ads: getTypeAdsValue(),
  type_currency: getTypeCurrencyValue(),
  offset: 0,
  page: getPage()
})

const selectedCategory = ref(null)
const selectedSubcategory = ref(null)
const selectedPlace = ref(null)
const placeName = ref(null)
const subcategories = ref(null)
const placesList = ref([])
const busy = ref(false)
const page = ref(0)
const arrayOfFilter = ref(getArrayOfParams())

const slug = (val) => $srbTolat.srbTolat(val?.name ?? '')

const currentCategoryParam = computed(() => {
  return props.routeMode === 'new'
    ? route.params.adcategory
    : route.params.category
})

const currentSubcategoryParam = computed(() => {
  return props.routeMode === 'new'
    ? route.params.adsubcategory
    : route.params.subcategory
})

const currentPlaceParam = computed(() => {
  return props.routeMode === 'new'
    ? route.query.place
    : route.params.place
})

const currentLawyernameParam = computed(() => route.params.lawyername)

const pageParam = computed(() => {
  if (props.routeMode === 'new') {
    return 1
  }

  return arrayOfFilter.value.length > 0
    ? arrToStringWithJoin(arrayOfFilter.value) + '-1'
    : 1
})

const selectBG = (select, item) => {
  return !!(select && select.id === item.id)
}

const selectAll = (item) => {
  if (props.routeMode === 'new') {
    return !selectedCategory.value && !selectedSubcategory.value
  }

  return item.includes('svi-oglasi')
}

const categoryByName = () => {
  if (!currentCategoryParam.value) return null

  const category = props.categories?.find(
    x => slug(x) === currentCategoryParam.value
  )

  return category || null
}

const subcategoryByName = () => {
  const category = categoryByName()
  if (!category || !currentSubcategoryParam.value) return null

  return category.subcategories?.find(
    x => slug(x) === currentSubcategoryParam.value
  ) || null
}

const placeByName = () => {
  if (!currentPlaceParam.value) return null

  return props.places?.find(
    x => slug(x) === currentPlaceParam.value
  ) || null
}

const syncSelectionsFromRoute = () => {
  selectedCategory.value = categoryByName()
  selectedSubcategory.value = subcategoryByName()
  selectedPlace.value = placeByName()

  filterData.value.type_ads = getTypeAdsValue()
  filterData.value.type_currency = getTypeCurrencyValue()
}

watch(
  () => props.places,
  (val) => {
    placesList.value = val || []
    syncSelectionsFromRoute()
  },
  { immediate: true }
)

watch(
  () => [route.fullPath, props.categories, props.places],
  () => {
    syncSelectionsFromRoute()
  },
  { deep: true }
)

const buildQueryForNewMode = () => {
  const query = {}

  if (selectedPlace.value) {
    query.place = slug(selectedPlace.value)
  }

  if (filterData.value.type_ads) {
    query.type_ads = filterData.value.type_ads
  }

  if (filterData.value.type_currency) {
    query.type_currency = filterData.value.type_currency
  }

  return query
}

const nuxtToOld = () => {
  const p = selectedPlace.value
  const c = selectedCategory.value
  const s = selectedSubcategory.value

  const base = { page: pageParam.value }

  if (p && c && s) {
    return router.push({
      name: 'oglasi-mesto-place-category-subcategory-page',
      params: {
        place: slug(p),
        category: slug(c),
        subcategory: slug(s),
        ...base
      }
    })
  }

  if (p && c && !s) {
    return router.push({
      name: 'oglasi-mesto-place-category-page',
      params: {
        place: slug(p),
        category: slug(c),
        ...base
      }
    })
  }

  if (p && !c) {
    return router.push({
      name: 'oglasi-mesto-place-page',
      params: {
        place: slug(p),
        ...base
      }
    })
  }

  if (c && s && !p) {
    return router.push({
      name: 'oglasi-category-subcategory-page',
      params: {
        category: slug(c),
        subcategory: slug(s),
        ...base
      }
    })
  }

  if (c && !p) {
    return router.push({
      name: 'oglasi-category-page',
      params: {
        category: slug(c),
        ...base
      }
    })
  }

  return router.push({
    name: 'oglasi-svi-oglasi-page',
    params: {
      page: pageParam.value
    }
  })
}

const nuxtToNew = () => {
  const lawyername = currentLawyernameParam.value
  const c = selectedCategory.value
  const s = selectedSubcategory.value
  const query = buildQueryForNewMode()

  if (c && s) {
    return router.push({
      name: 'tezga-lawyername-adcategory-adsubcategory-page',
      params: {
        lawyername,
        adcategory: slug(c),
        adsubcategory: slug(s),
        page: 1
      },
      query
    })
  }

  if (c && !s) {
    return router.push({
      name: 'tezga-lawyername-adcategory-page',
      params: {
        lawyername,
        adcategory: slug(c),
        page: 1
      },
      query
    })
  }

  return router.push({
    name: 'tezga-lawyername-page',
    params: {
      lawyername,
      page: 1
    },
    query
  })
}

const nuxtTo = () => {
  if (props.routeMode === 'new') {
    return nuxtToNew()
  }

  return nuxtToOld()
}

const selectCategory = (category) => {
  if (selectedCategory.value && selectedCategory.value.id === category.id) {
    selectedCategory.value = null
    selectedSubcategory.value = null
  } else {
    selectedCategory.value = category
    subcategories.value = category.subcategories
    selectedSubcategory.value = null
  }

  nuxtTo()
  clickShow()
}

const selectSubcategory = (subcategory) => {
  if (selectedSubcategory.value && selectedSubcategory.value.id === subcategory.id) {
    selectedSubcategory.value = null
  } else {
    selectedSubcategory.value = subcategory
  }

  nuxtTo()
  clickShow()
}

const selectPlace = (place) => {
  if (selectedPlace.value && selectedPlace.value.id === place.id) {
    selectedPlace.value = null
  } else {
    selectedPlace.value = place
  }

  nuxtTo()
  clickShow()
}

const filtersAdsType = () => {
  if (props.routeMode === 'old') {
    arrayOfFilter.value = arrayOfFilter.value.filter(
      x => x !== 'kupujem' && x !== 'prodajem'
    )

    if (filterData.value.type_ads != null) {
      arrayOfFilter.value.push(filterData.value.type_ads)
    }
  }

  nuxtTo()
  clickShow()
}

const filtersAdsTypeCurrency = () => {
  if (props.routeMode === 'old') {
    arrayOfFilter.value = arrayOfFilter.value.filter(
      x => x !== 'cena' && x !== 'dogovor'
    )

    if (filterData.value.type_currency != null) {
      arrayOfFilter.value.push(filterData.value.type_currency)
    }
  }

  nuxtTo()
  clickShow()
}

const allCategories = () => {
  selectedCategory.value = null
  selectedSubcategory.value = null
  nuxtTo()
  clickShow()
}

const loadMorePlaces = async () => {
  if (busy.value) return

  busy.value = true

  setTimeout(async () => {
    page.value += 1

    const { data } = await useDistrictStore.getPlacePaginateCache({
      name: placeName.value,
      place: props.routeMode === 'old'
        ? (route.params.place != undefined ? route.params.place.split('-').join(' ') : '')
        : (route.query.place != undefined ? String(route.query.place).split('-').join(' ') : ''),
      page: page.value
    })

    placesList.value = data
    busy.value = false
  }, 1000)
}

const findPlaceByName = async () => {
  busy.value = true
  page.value = 1

  const { data } = await useDistrictStore.getPlacePaginateCache({
    name: placeName.value,
    place: props.routeMode === 'old'
      ? (route.params.place != undefined ? route.params.place.split('-').join(' ') : '')
      : (route.query.place != undefined ? String(route.query.place).split('-').join(' ') : ''),
    page: 1
  })

  placesList.value = data
  busy.value = false
}

// pretraga kategorija u listi (lokalno, bez kvacica)
const categoryQuery = ref('')

const visibleCategories = computed(() => {
  const list = props.categories ?? []
  const query = normalizeText(categoryQuery.value)

  return query ? list.filter((category) => normalizeText(category.name).includes(query)) : list
})

// vrednost iz rute moze biti prazan niz: za prikaz je to "sve" (null)
const plainValue = (value) => {
  const single = Array.isArray(value) ? value[0] : value

  return single ? single : null
}

const currentType = computed(() => plainValue(filterData.value.type_ads))
const currentCurrency = computed(() => plainValue(filterData.value.type_currency))

// "Sve / kupujem / prodajem" i "Sve / cena / dogovor" su prekidaci (jedan klik)
const setType = (value) => {
  filterData.value.type_ads = value
  filtersAdsType()
}

const setCurrency = (value) => {
  filterData.value.type_currency = value
  filtersAdsTypeCurrency()
}

// izabrani filteri kao cipovi; klik na cip uklanja samo taj filter
const chips = computed(() => {
  const list = []

  if (selectedCategory.value) {
    list.push({ key: 'category', label: selectedCategory.value.name, remove: () => selectCategory(selectedCategory.value) })
  }

  if (selectedSubcategory.value) {
    list.push({ key: 'subcategory', label: selectedSubcategory.value.name, remove: () => selectSubcategory(selectedSubcategory.value) })
  }

  if (selectedPlace.value) {
    list.push({ key: 'place', label: selectedPlace.value.name, remove: () => selectPlace(selectedPlace.value) })
  }

  if (currentType.value) {
    list.push({ key: 'type', label: currentType.value, remove: () => setType(null) })
  }

  if (currentCurrency.value) {
    list.push({ key: 'currency', label: currentCurrency.value, remove: () => setCurrency(null) })
  }

  return list
})

const clearAll = () => {
  selectedCategory.value = null
  selectedSubcategory.value = null
  selectedPlace.value = null
  filterData.value.type_ads = null
  filterData.value.type_currency = null
  arrayOfFilter.value = []

  nuxtTo()
  clickShow()
}

const clickShow = () => {
  const nav = document.getElementById('nav-container')
  const aweUp = document.getElementById('up-awesome')
  const aweDown = document.getElementById('down-awesome')

  if (!nav || !aweUp || !aweDown) return

  if (nav.classList.contains('show-container')) {
    nav.classList.remove('show-container')
    aweDown.classList.remove('d-none')
    aweDown.classList.add('d-block')
    aweUp.classList.remove('d-block')
    aweUp.classList.add('d-none')
  } else {
    nav.classList.add('show-container')
    aweDown.classList.remove('d-block')
    aweDown.classList.add('d-none')
    aweUp.classList.remove('d-none')
    aweUp.classList.add('d-block')
  }
}

const resizeExpanded = () => {
  const nav = document.getElementById('nav-container')
  const aweUp = document.getElementById('up-awesome')
  const aweDown = document.getElementById('down-awesome')
  const width = window.innerWidth

  if (!nav || !aweUp || !aweDown) return

  if (width >= 990) {
    if (aweDown.classList.contains('d-none')) {
      aweDown.classList.remove('d-none')
      aweDown.classList.add('d-block')
    }

    if (aweUp.classList.contains('d-block')) {
      aweUp.classList.remove('d-block')
      aweUp.classList.add('d-none')
    }

    nav.classList.remove('show-container')
  }
}

const handleScroll = () => {
  const listElm = infiniteListRef.value
  if (!listElm) return

  if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight - 10) {
    loadMorePlaces()
  }
}

onMounted(() => {
  window.addEventListener('resize', resizeExpanded)

  nextTick(() => {
    if (infiniteListRef.value) {
      infiniteListRef.value.addEventListener('scroll', handleScroll)
    }
  })

  syncSelectionsFromRoute()
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', resizeExpanded)

  if (infiniteListRef.value) {
    infiniteListRef.value.removeEventListener('scroll', handleScroll)
  }
})
</script>

<style scoped>
</style>